<template>
    <div class="dcpdetail">
        <el-tabs class="tabs" v-model="selectedTab" @tab-click="handleClick" :style="hasUpdate ? {width:'240px'} : {width: '120px'}">
            <el-tab-pane :label="$t('app.dcp_data_info')" name="1"></el-tab-pane>
            <el-tab-pane :label="$t('app.dcp_data_update')" name="2" v-if="hasUpdate"></el-tab-pane>
        </el-tabs>
        <div class="render">
            <el-form ref="form">
                <render
                    :jsonContent="template"
                    :datamodel="datamodelData"
                    ref="childComponents"
                    :referenceList="referenceList"
                    :disabled="true"
                    :contextData="contextData"
                />
                </el-form>
        </div>
    <template v-if="hasUpdate">
    <div class="bottom-container-margin" style="height: 80px"></div>
    <div class="bottom-container">
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col>
          <el-button
            class="btn-black-color"
            @click="updateDcpReflist"
            round
          >{{$t('app.update')}}</el-button>
        </el-col>
      </el-row>
    </div>
    </template>
    </div>
</template>

<script>
import render from "@/pages/dcpdetail/render";
import refdcp from '@/localdata/refdcpwithdata';
import callApp from "@/services/sdk";

import { mapGetters } from 'vuex'
export default {
components: {
    render
},
data() {
return {
    template: "",
    datamodelData: "",
    newTemplate: "",
    newDataModel: "",
    cbJson: {},
    selectedTab: "1",
    referenceList: '',
    dcpreferences: [],
    refDcpConfigList: []
};
},
computed: {
    ...mapGetters([
      'getViewDcp'
    ]),
    hasUpdate() {
        return this.getViewDcp.lastestDataHash &&
            this.getViewDcp.lastestDataHash != this.getViewDcp.dataHash && this.getViewDcp.lastestDataHash.length > 0
    },
    contextData() {
      return {
        "refDcpConfigList": this.refDcpConfigList,
        "dcpreferences": this.dcpreferences
      }
    }
},
watch: {

},
methods: {
    handleClick() {
        try {

        const viewDcp = this.getViewDcp
        if(this.selectedTab === "2") {
            viewDcp.dataHash = this.getViewDcp.lastestDataHash
        }

        callApp(
            "getData",
            {
            type: `dataSource.server.getrefdcpdetail`,
            data: viewDcp
            },
            "cbGetData"
        ).then(data => {
            const templateData = data
            if (templateData.language && Object.keys(templateData.language).length > 0) {
                this.$store.state.languagePackage.push(templateData.language);
            }

            this.datamodelData = templateData.data;
            this.template = templateData.template.attributes;
            this.referenceList = templateData.referenceList;
            });
        } catch (err) {}
    },
    updateDcpReflist() {
        const updateDcp = this.getViewDcp
        updateDcp.dataHash = this.getViewDcp.lastestDataHash
        updateDcp["replaceOrigin"] = true

        this.$store.dispatch('setViewDcp', updateDcp)
        /// update dcp data
        // setTimeout(()=>{
            this.$router.back()
        // }, 300)
    }
},
created() {

},
mounted() {
    try {

      const viewDcp = this.getViewDcp

      callApp(
        "getData",
        {
          type: `dataSource.server.getrefdcpdetail`,
          data: viewDcp
        },
        "cbGetData"
      ).then(data => {
          const templateData = data
          if (templateData.language && Object.keys(templateData.language).length > 0) {
            this.$store.state.languagePackage.push(templateData.language);
          }

          this.datamodelData = templateData.data;
          this.dcpreferences = data.data && data.data.dcpreferences;
          this.template = templateData.template.attributes;
          this.referenceList = templateData.referenceList;
        });
    } catch (err) {}
},
}
</script>
<style lang='scss' scoped>

.dcpdetail {
    padding: 10px;
    font-size: 14px;
}
.tabs {
    width: 160px;
}
.bottom-container {
  bottom: 0px;
  padding: 10px;
  margin: 0 auto;
  left: 0px;
  right: 0px;
  height: 80px;
  max-width: 750px;
  position: fixed;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 1002;
}
</style>
